module.exports = __webpack_public_path__ + "media/images/travel-23114341.png";